/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import {Component, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {environment} from '../environments/environment';

@Component({
	selector: 'ngx-app',
	template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {

	constructor(translate: TranslateService) {
		translate.addLangs([environment.defaultLang]);
		translate.setDefaultLang(environment.defaultLang);
		translate.use(environment.defaultLang);
	}

	ngOnInit(): void {
	}
}
